import { render, staticRenderFns } from "./file-preview-container.vue?vue&type=template&id=0588a6dc"
import script from "./file-preview-container.vue?vue&type=script&lang=js"
export * from "./file-preview-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports